<template>
  <div class="place-facility-group-tab shared-index">
    <el-row class="table-title" type="flex" align="center">
      <div class="table-title__left">
        <el-tabs v-model="activeTab" type="card" @tab-click="handleChangeTab">
          <el-tab-pane name="place_facility_groups">
            <div slot="label">
              Nhóm tiện ích
              <span v-if="activeTab === 'place_facility_groups'">({{ total }})</span>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div style="display: flex; align-items: center;">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          size="small"
          class="mr-2"
          @click="createPlaceFacilityGroup"
        >Thêm</el-button>
        <import-excel-button
          size="small"
          class="mr-2"
          :disabled="callingAPI"
          :total="total"
          :columns="excelColumns"
          :type="'place-facility-groups'"
          :titles="pageTitles"
          :active-tab="activeTab"
          @reload="loadData"
        />
        <export-excel-button
          size="small"
          class="mr-2"
          :disabled="callingAPI || total === 0"
          :total="total"
          :columns="excelColumns"
          :type="'place-facility-groups'"
          :titles="pageTitles"
          :active-tab="activeTab"
        />
        <translate-button
          size="small"
          class="mr-2"
          :disabled="callingAPI"
          :total="total"
          :columns="excelColumns"
          :type="'place-facility-groups'"
          :titles="pageTitles"
          :active-tab="activeTab"
          @reload="loadData"
        />
        <el-button
          type="primary"
          icon="el-icon-refresh-right"
          size="small"
          @click="handleChangeTab"
        >Làm mới</el-button>
      </div>
    </el-row>
    <list-place-facility-groups
      :loading="callingAPI"
      :data="allPlaceFacilityGroups"
      @reload="handleReloadAfterDelete"
      @update="updatePlaceFacilityGroup"
    />
    <el-row type="flex" justify="end" class="my-4">
      <el-pagination
        :current-page="page"
        :page-size="limit"
        :total="total"
        background
        layout="total, prev, pager, next"
        @current-change="handleChangePage"
      ></el-pagination>
    </el-row>
    <update-place-facility-group-popup
      v-if="visibleUpdate"
      :place-facility-group="selectedPlaceFacilityGroup"
      :visible="visibleUpdate"
      @close="visibleUpdate = false"
      @reload="loadData"
      @reload-constant="handleReloadConstant"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { mapGetters, mapActions } from 'vuex'
import ListPlaceFacilityGroups from './components/List.vue'
import UpdatePlaceFacilityGroupPopup from './components/popup/Update.vue'
import ImportExcelButton from '@/components/buttons/ImportExcel.vue'
import ExportExcelButton from '@/components/buttons/ExportExcel.vue'
import TranslateButton from '@/components/buttons/Translate.vue'
import TYPE from '@/data/type'
import { getTranslation } from '@/utils/filters'
import { getPlaceFacilityGroups } from '@/services/place/facility-group'

export default {
  name: 'PlaceFacilityGroups',
  components: {
    ListPlaceFacilityGroups,
    UpdatePlaceFacilityGroupPopup,
    ImportExcelButton,
    ExportExcelButton,
    TranslateButton
  },
  data() {
    return {
      visibleUpdate: false,
      callingAPI: false,
      allPlaceFacilityGroups: [],
      selectedPlaceFacilityGroup: {},
      activeTab: 'place_facility_groups',
      total: 0,
      limit: 10,
      page: 1,
      searchText: ''
    }
  },
  computed: {
    ...mapGetters(['language']),
    excelColumns() {
      const eColumns = (this.$route.meta.data && this.$route.meta.data.index && this.$route.meta.data.index.excelColumns) || ['id', 'name']
      return (eColumns || []).map((c) =>
        TYPE.EXCEL_COLUMNS.find((column) => c === column.key)
      )
    },
    pageTitles() {
      return [{ name: 'Nhóm tiện ích', label: 'Nhóm tiện ích', value: 'place-facility-groups' }]
    },
    params() {
      return {
        page: this.page,
        per_page: this.limit,
        locale: this.language
      }
    }
  },
  watch: {
    language: 'loadData'
  },
  beforeMount() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.callingAPI = true
      this.visibleUpdate = false
      getPlaceFacilityGroups(this.params).then((response) => {
        this.allPlaceFacilityGroups = (response.result || []).map((r) => ({
          ...r,
          name: getTranslation(r, this.language) ? getTranslation(r, this.language).name : r.name
        }))
        this.total = response.total || 0
        this.callingAPI = false
      }).catch(() => {
        this.callingAPI = false
      })
    },
    handleChangePage(page) {
      this.page = page
      this.loadData()
    },
    createPlaceFacilityGroup() {
      this.selectedPlaceFacilityGroup = null
      this.visibleUpdate = true
    },
    updatePlaceFacilityGroup(data) {
      this.selectedPlaceFacilityGroup = data
      this.visibleUpdate = true
    },
    handleChangeTab() {
      this.page = 1
      this.loadData()
    },
    ...mapActions('public', ['updateReloadConstant']),
    handleReloadConstant() {
      this.updateReloadConstant(dayjs().unix())
    },
    handleReloadAfterDelete() {
      if (this.allPlaceFacilityGroups.length === 1 && this.page > 1) {
        this.page = this.page - 1
      }
      this.loadData()
      this.handleReloadConstant()
    }
  }
}
</script>

<style lang="scss" scoped>
.place-facility-group-tab {
  .table-title {
    &__left {
      max-width: calc(100% - 200px);
      .el-tabs {
        max-width: 100%;
      }
    }
  }
}
</style>
